import { loadCollectionItems } from '../pluginComponentApi';

export default async function (editor, opt = {}) {
  const { projectId, version } = opt;
  const traitManager = editor.TraitManager;
  const roleItems = await loadCollectionItems(projectId, version, 'role');

  traitManager.addType('role-trait', {
    createInput({ trait }) {
      let input = document.createElement('select');
      let attrId = document.createAttribute('id');
      attrId.value = 'drapcode-role-select';
      input.setAttributeNode(attrId);

      let defaultOption = document.createElement('option');
      defaultOption.text = '- Select One -';
      defaultOption.value = '';
      input.append(defaultOption);

      for (let i = 0; i < roleItems.length; i++) {
        let name = roleItems[i].name;
        let value = `${roleItems[i].name}`;
        let option = document.createElement('option');
        option.text = name;
        option.value = value;
        input.append(option);
      }

      return input;
    },
    onEvent({ elInput, component }) {
      const name = this.model.get('name');
      const value = this.model.get('value');
      let attrs = component.getAttributes();

      if (value) {
        const allTraits = component.get('traits');
        const traitsSize = allTraits.length;
        const roles = allTraits.filter((trait) => trait.attributes['type'] === 'role-trait');

        if (roleItems && roleItems.length > roles.length) {
          component.addTrait(
            {
              type: `role-trait`,
              name: `data-role-${roles.length}`,
              label: `Role #${roles.length}`,
            },
            { at: traitsSize },
          );
        }
      } else if (name) {
        delete attrs[name];
        component.removeTrait(name);
        component.setAttributes(attrs);
      }
    },
    onUpdate({ elInput, component }) {
      const attr = component.getAttributes();
      const name = this.model.get('name');

      elInput.value = attr[name] ? attr[name].trim() : '';
    },
  });
}
